import { numberFormat } from '@fiverr-private/localization';

const number = (number) =>
    numberFormat(number, {
        fallbackValue: number.toLocaleString(),
    });

export default number;
